'use client';
import { ReactNode, useState } from 'react';
import cn from 'classnames';
import Image from 'next/image';
import LoginImage from 'public/img/login-photo.webp';
import BackupLoginImage from 'public/img/login-photo.jpg';
import './AuthPageLayout.style.scss';

type AuthPageLayoutProps = {
  className?: string;
  children?: ReactNode;
};

const AUTH_PAGE_PHOTO_HEIGHT = 783;
const AUTH_PAGE_PHOTO_WIDTH = 707;

function AuthPageLayout(props: AuthPageLayoutProps) {
  const { className = '', children } = props;
  const [imgSrc, setImgSrc] = useState(LoginImage);

  return (
    <div className={cn('AuthPageLayout', className)}>
      <div className='AuthPageLayout-half left'>
        <div className='AuthPageLayout-form-container'>{children}</div>
      </div>
      <div className='AuthPageLayout-half right'>
        <Image
          className='AuthPageLayout-img'
          alt={'Woman on a pink couch showing off a designer handbag'}
          height={AUTH_PAGE_PHOTO_HEIGHT}
          width={AUTH_PAGE_PHOTO_WIDTH}
          src={imgSrc}
          onError={() => {
            // If there's any issue displaying the webp image,
            // display the jpg version
            setImgSrc(BackupLoginImage);
          }}
          loading={'eager'}
        />
      </div>
    </div>
  );
}

export default AuthPageLayout;
